import { Controller } from "stimulus";
import $ from 'jquery';
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");

export default class extends Controller {
    static targets = ['selectedformtype','selectedModalityValue','button']

    connect() {
        $('.visit-search').select2();
        $('.select2-container--default .select2-selection--multiple').css({
            'min-height': '42px',
            'border-color': '#cbd5e0'
        });
    }
    generateSASToken(event) {
      const button = event.currentTarget;
      const export_id = this.element.dataset.id;
      const study_id = this.element.dataset.studyId;
      const progressMessage = document.getElementById(`progressMessage_${export_id}`);
      // Hide the button
      button.style.display = "none";
      // Show the "In Progress" message
      progressMessage.classList.remove("hidden");
      this.nodeURL = this.element.dataset.uploadUrl;
        getFileShareSASToken(export_id, study_id, this.nodeURL);
    }
}
async function getFileShareSASToken(export_id, study_id,nodeURL) {
    try {
      const response = await fetch(nodeURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        },
      });
      if (!response.ok) {
        const errorDetails = await response.json();
        throw new Error(`HTTP error! status: ${response.status}, details: ${JSON.stringify(errorDetails)}`);
      }
 
      const data = await response.json();
      const url = `${document.location.origin}/studies/${study_id}/full_data_exports/download_images`;
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ full_data_export_id: export_id, sas_token: data.sas_token, study_id: study_id })
      })
      .then(response => {
        console.log("The response data is completed. . . . ")
      });

    } catch (error) {
      console.error("An error occurred during the file upload process:", error.message);
    }
  }